import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ConfigService } from '@core/shared/config';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { firstValueFrom, take } from 'rxjs';
import { loadPaypalJs } from '../load-paypal-js';
import { MembershipRegistrationActions, MembershipRegistrationFacade } from './registration.actions';
import { MembershipRegistrationCartService } from './cart.service';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/config";
import * as i2 from "./registration.actions";
import * as i3 from "./cart.service";
import * as i4 from "@ngxs/store";
/**
 * MembershipPaypalService is not controlled by state.
 * Instead it is used by RegistrationCheckoutComponent.
 * When payment is done, it dispatches CompletePaypalOrder to notify state.
 */
export let MembershipPaypalService = /*#__PURE__*/(() => {
  class MembershipPaypalService {
    constructor(config, registration, cartService, store, actions$) {
      this.config = config;
      this.registration = registration;
      this.cartService = cartService;
      this.store = store;
      this.actions$ = actions$;
      // createOrder must return the ID of server-side created paypal order
      this.createOrder = (data, actions) => {
        const submitCompletion = this.actions$.pipe(ofActionSuccessful(MembershipRegistrationActions.SubmitCompleted), take(1));
        this.registration.submit();
        const pageTitle = this.config.get('pageTitle');
        const orderInfos = this.transformCartToPaypalData();
        return firstValueFrom(submitCompletion).then(({
          response,
          error
        }) => {
          if (error) {
            throw error;
          } else {
            return actions.order.create({
              intent: 'CAPTURE',
              purchase_units: [{
                amount: orderInfos.ppAmount,
                items: orderInfos.ppItems
              }],
              // payer can specify address details for prefilled forms
              // payer?: Payer,
              application_context: {
                brand_name: pageTitle
                // locale: 'de_DE',
                // landing_page?: "LOGIN" | "BILLING" | "NO_PREFERENCE";
                // shipping_preference?: SHIPPING_PREFERENCE;
                // user_action?: "CONTINUE" | "PAY_NOW";
                // payment_method?: Record<string, unknown>;
                // return_url?: string;
                // cancel_url?: string;
                // stored_payment_source?: Record<string, unknown>;
              }
            });
          }
        }).then(ppOrderId => {
          this.store.dispatch(new MembershipRegistrationActions.SetPaypalOrderId(ppOrderId));
          return ppOrderId;
        });
      };
      // Finalize the transaction on the server after payer approval
      this.onApprove = (data, actions) => {
        /**
         * Logic of paypal seems to be:
         * onApprove is called when the buyer APPROVED payment but it has not been executed.
         * its now our task to either capture (immediate payment) or authorize (payment can be executed in next 30 days) the order.
         */
        actions.order.capture().then(response => {
          this.store.dispatch(new MembershipRegistrationActions.CompletePaypalOrder({
            orderDetails: data,
            error: false
          }));
        }, error => {
          this.store.dispatch(new MembershipRegistrationActions.CompletePaypalOrder({
            orderDetails: null,
            error: error
          }));
        });
      };
      this.onCancel = (data, actions) => {
        this.store.dispatch(new MembershipRegistrationActions.CompletePaypalOrder({
          orderDetails: null,
          error: "Paypal Zahlung wurde abgebrochen."
        }));
      };
      this.onError = error => {
        console.log(error);
        this.store.dispatch(new MembershipRegistrationActions.CompletePaypalOrder({
          orderDetails: null,
          error: error
        }));
      };
      // defaults to sandbox ID managed via info@yooniversity.com account
      const paypalClientId = this.config.get('membership.paypalClientId', 'AcIpz-bvZIPWaDBO22dy2Vl9h7QGkvJIsNReHAq1Givl2dv5aYc1elCgf0jrz2vxGxKBYqncYuCylSUV');
      this.ppLoader = loadPaypalJs(paypalClientId).then(pp => {
        this.paypal = pp;
      });
    }
    createPaypalButtonComponent() {
      var _this = this;
      return _asyncToGenerator(function* () {
        if (!_this.paypal) yield _this.ppLoader;
        return _this.paypal.Buttons({
          style: {
            shape: 'pill',
            color: 'blue',
            layout: 'horizontal',
            label: 'buynow',
            tagline: false
          },
          createOrder: _this.createOrder,
          onApprove: _this.onApprove,
          onCancel: _this.onCancel,
          onError: _this.onError
        });
      })();
    }
    transformCartToPaypalData() {
      const pageId = this.config.get('id');
      const membershipCartItemsAndValue = this.cartService.getItemsAndValue();
      const totals = this.cartService.getCartTotals();
      const ppItems = membershipCartItemsAndValue.map((entry, i) => {
        return {
          name: pageId + '_' + entry.item.id,
          quantity: entry.value.quantity.toString(),
          unit_amount: {
            currency_code: 'EUR',
            value: entry.value.netValue.toFixed(2)
          },
          tax: {
            currency_code: 'EUR',
            value: entry.value.taxValue.toFixed(2)
          },
          description: entry.item.title,
          category: "DIGITAL_GOODS"
        };
      });
      const ppAmount = {
        currency_code: 'EUR',
        value: totals.grossValue.toPrecision(2).toString(),
        breakdown: {
          item_total: {
            currency_code: 'EUR',
            value: totals.netValue.toFixed(2)
          },
          tax_total: {
            currency_code: 'EUR',
            value: totals.taxValue.toFixed(2)
          }
          // 	shipping?: AmountWithCurrencyCode;
          // 	handling?: AmountWithCurrencyCode;
          // 	insurance?: AmountWithCurrencyCode;
          // 	shipping_discount?: AmountWithCurrencyCode;
          // 	discount?: AmountWithCurrencyCode;
        }
      };
      return {
        ppItems,
        ppAmount
      };
    }
    static {
      this.ɵfac = function MembershipPaypalService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembershipPaypalService)(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.MembershipRegistrationFacade), i0.ɵɵinject(i3.MembershipRegistrationCartService), i0.ɵɵinject(i4.Store), i0.ɵɵinject(i4.Actions));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: MembershipPaypalService,
        factory: MembershipPaypalService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MembershipPaypalService;
})();